'use client';

import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { toggleCookieBanner } from '../onetrust';

export interface OpenCookieSettingsButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'onClick'> {
  children?: ReactNode;
}

/** Unstyled trigger for the OneTrust preference center — bring your own markup/classes. */
export function OpenCookieSettingsButton({ children, ...rest }: OpenCookieSettingsButtonProps) {
  return (
    <button type='button' onClick={() => void toggleCookieBanner()} {...rest}>
      {children}
    </button>
  );
}
